/* global Swiper */
(() => {
  const SELECTOR = '[data-set-carousel]';
  const instances = new WeakMap();

  function num(value, fallback) {
    const parsed = parseFloat(value);
    return Number.isNaN(parsed) ? fallback : parsed;
  }

  function init(el) {
    if (typeof Swiper === 'undefined') return;

    const existing = instances.get(el);
    if (existing) {
      existing.update();
      return;
    }

    const root = el.closest('.product-set') || el.parentElement;

    instances.set(
      el,
      new Swiper(el, {
        slidesPerView: num(el.dataset.slidesMobile, 2),
        spaceBetween: num(el.dataset.gapMobile, 10),
        breakpoints: {
          768: {
            slidesPerView: num(el.dataset.slidesDesktop, 2),
            spaceBetween: num(el.dataset.gapDesktop, 10)
          }
        },
        grabCursor: true,
        watchOverflow: true,
        navigation: {
          prevEl: root.querySelector('[data-set-prev]'),
          nextEl: root.querySelector('[data-set-next]')
        }
      })
    );
  }

  function initAll() {
    document.querySelectorAll(SELECTOR).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
